import React from 'react';
import AddInventoryTransactionForm from './AddInventoryTransactionForm';

function AddWastage(props) {
    const { route } = props;
    const isWastage = route === 'wastage';
    return (
        <AddInventoryTransactionForm
            {...props}
            title={`Submit ${isWastage ? 'Wastage' : 'Usage'}`}
            listEndpoint="/pos/inventory/list/"
            submitEndpoint={isWastage ? '/pos/inventory/add/wastage/' : '/pos/inventory/add/usage/'}
            successMessage={isWastage ? 'Wastage Updated' : 'Usage Updated'}
            navigateTo="/"
        />
    );
}

export default AddWastage;
